
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/project/infrastructure/railway",
      function () {
        return require("private-next-pages/project/infrastructure/railway.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/project/infrastructure/railway"])
      });
    }
  